import { getString } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'ConfirmButton',

  mixins: [ proxy() ],

  props: {
    title: [ String, Number, Boolean ],
    info: [ String, Number, Boolean ],

    callback: {
      type: Function,
      required: true
    }
  },

  computed: {
    $_title() {
      if (this.title) {
        return getString(this.title)
      }

      return this.getTranslate('commons.titles.confirm.title')
    },

    $_info() {
      if (this.info) {
        return getString(this.info)
      }

      return this.getTranslate('commons.contents.confirm.confirm')
    }
  },

  render
}
